import type { SxProps, Theme } from '@mui/material/styles';

/**
 * Shared date picker styles for dashboard widgets.
 *
 * Targets MUI X pickers classes to:
 * - remove the outlined fieldset border
 * - apply a custom border + text/icon color on the pickers input base
 * - tighten section padding
 */
export const DASHBOARD_WIDGET_DATE_PICKER_SX: SxProps<Theme> = (theme) => {
  const primary = theme.palette.primary.main;

  return {
    '& fieldset': {
      border: 'none !important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
    '& .MuiPickersInputBase-root': {
      border: `1px ${primary} solid !important`,
      color: `${primary} !important`,
      borderRadius: '8px',
    },
    '& .MuiPickersInputBase-root .MuiInputBase-input': {
      color: `${primary} !important`,
    },
    '& .MuiPickersInputBase-root .MuiSvgIcon-root': {
      color: `${primary} !important`,
    },
    '& .MuiPickersSectionList-root': {
      padding: '6px 0px !important',
    },
  };
};
